import { useEffect, useState } from 'react'

import { fetchEnabledClients, getClientKey } from '../../../../api/blockBillingApi'

/**
 * Client ids that have block billing enabled, regardless of who enabled
 * them. Used to show the block billing indication on matter group headers
 * in the TimeEntry Grid.
 */
export const useBlockBillingClientIds = (): Set<string> => {
  const [clientIds, setClientIds] = useState<Set<string>>(
    () => new Set<string>()
  )

  useEffect(() => {
    let mounted = true

    fetchEnabledClients()
      .then(clients => {
        if (!mounted) return
        setClientIds(new Set(clients.map(getClientKey)))
      })
      .catch(error => {
        console.error('Failed to fetch block billing enabled clients', error)
      })

    return () => {
      mounted = false
    }
  }, [])

  return clientIds
}
